import type { Tool } from '@agents/shared';
import { Icon } from '../components/icons';
import { ErrorState, PageHeader, SkeletonRows } from '../components/ui';
import { useDocumentTitle } from '../lib/document-title';
import { useTools } from '../lib/queries';

const GROUPS: { kind: Tool['kind']; title: string; text: string }[] = [
  { kind: 'read', title: 'Consultas', text: 'Solo leen información. No cambian nada fuera de la ejecución.' },
  {
    kind: 'action',
    title: 'Acciones',
    text: 'Pueden crear o modificar datos en otros sistemas. Autorízalas solo a los agentes que las necesiten.',
  },
];

function ToolRow({ tool }: { tool: Tool }) {
  return (
    <div className="list-row" data-kind={tool.kind}>
      <span className="tool-icon">
        <Icon name={tool.kind === 'action' ? 'zap' : 'eye'} />
      </span>
      <div>
        <h3>
          {tool.name}
          <span className="chip">{tool.id}</span>
          {tool.status === 'disabled' && <span className="chip">Desactivada</span>}
        </h3>
        <p>{tool.description}</p>
      </div>
      <span className="source mono muted">{tool.source}</span>
    </div>
  );
}

export function ToolsPage() {
  useDocumentTitle('Herramientas');
  const tools = useTools();
  return (
    <>
      <PageHeader
        title="Herramientas"
        description="Capacidades que los agentes pueden usar. Cada agente accede solo a las que un administrador le autoriza al editarlo."
      />
      {tools.isPending && <SkeletonRows />}
      {tools.isError && <ErrorState error={tools.error} onRetry={() => void tools.refetch()} />}
      {tools.data &&
        GROUPS.map((g) => {
          const items = tools.data.filter((t) => t.kind === g.kind);
          if (!items.length) return null;
          return (
            <section key={g.kind}>
              <div className="group-head">
                <h2>{g.title}</h2>
                <p>{g.text}</p>
              </div>
              <div className="list-panel">
                {items.map((t) => (
                  <ToolRow key={t.id} tool={t} />
                ))}
              </div>
            </section>
          );
        })}
    </>
  );
}
